//@ts-ignore
//@ts-nocheck
import React, { useState, useEffect } from "react";
import {
  Popconfirm,
  Table,
  Button,
  Input,
  Form,
  Modal,
  Checkbox,
  Row,
  Col,
  Tooltip,
  Collapse,
  ConfigProvider,
  Divider,
  Radio,
} from "antd";
import { PlusOutlined, EditOutlined, HistoryOutlined } from "@ant-design/icons";
import IDynamicTable from "./IDynamicTable";
import {
  BsColumns,
  BsPinAngle,
  BsPinAngleFill,
  BsPinFill,
  BsThreeDotsVertical,
} from "react-icons/bs";
import TableFilters from "./TableFilters";
import { FaFilter } from "react-icons/fa6";
import Panel from "antd/es/splitter/Panel";
import "../../App.css";
import { useNavigate } from "react-router-dom";
import type { TableColumnsType, TableProps } from "antd";
import Item from "antd/es/list/Item";
import { APICall } from "../../Helpers/APICalls/APICalls";
import { fetchReportData } from "../../Helpers/APIEndpoints/Endpoints";
import { API } from "../../Axios/Axios";

const FormInlineTable = ({
  fields = [],
  name,
  onChange,
  keyIdentity = null,
  form,
  field = {},
  ...rest
}: any) => {
  const [data, setData] = useState([]);

  const [updatedColumns, setUpdatedColumns] = useState([]);
  const [visibleColumns, setVisibleColumns] = useState([]);

  const [isVisibleColumnsModalVisible, setVisibleColumnsModalVisible] =
    useState(false);
  const [visibleColumnsModalSearchText, setVisibleColumnsModalSearchText] =
    useState<string>(""); // State for search input

  const navigate = useNavigate();
  // const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  useEffect(() => {
    if (fields && fields.length > 0) {
      setTableColumnFunction();
      callTableDataApi();
    }
  }, [fields]);

  const setTableColumnFunction = () => {
    let tempCol = [];
    setVisibleColumns(
      [...fields].map((data) => {
        return data.name;
      })
    );

    for (let index = 0; index < fields.length; index++) {
      const element = fields[index];

      const colObj = {
        key: element.name,
        dataIndex: element.name,
        title: element.label,
        isFieldEditable: element?.isFieldEditable,
        Id: element.Id,
        fieldInterfaceId: element.fieldInterfaceId,
        parentId: element.parentId,
        IsActive: element.IsActive,
        rowSpan: element.rowSpan,
        rowSpanStart: element.rowSpanStart,
        rowSpanEnd: element.rowSpanEnd,
      };

      tempCol.push(colObj);
    }

    setUpdatedColumns(tempCol);
  };

  const callTableDataApi = async () => {
    try {
      const request = {
        UserId: 6,
        RoleId: 1,
        PageNumber: PageNumber,
        PageSize: PageSize,
        interfaceId: field.fieldInterfaceId,
      };
      const response = await API.post(fetchReportData);

      if (
        response &&
        response.status == 0 &&
        response.data &&
        response.data.length > 0
      ) {
        // setData(response.data)
      }
    } catch (err) {
      console.log("Errr from callTableDataApi: ", err);
    }
  };

  const mergedColumns = updatedColumns
    .map((col: any) => {
      console.log("col: ", col);
      return {
        ...col,
        onCell: (record: any, index: number) => {
          console.log("record: ", record);
          console.log("col: ", col.type, col.rowSpan);
          console.log("dddd index: ", col.title, index);
          let onCellObj = {
            record,
            inputType: col.type,
            dataIndex: col.name,
            title: col.title,
            editing: col.isFieldEditable,
          };
          if (col.rowSpan) {
            const rowSpanStart =
              col.rowSpanStart && col.rowSpanStart > 0
                ? col.rowSpanStart - 1
                : 0;

            const rowSpanEnd =
              col.rowSpanEnd && data.length >= col.rowSpanEnd
                ? col.rowSpanEnd
                : data.length;

            if (index === rowSpanStart) {
              onCellObj = {
                ...onCellObj,
                rowSpan: rowSpanEnd - rowSpanStart,
              }; // Apply rowspan to the first row
            } else if (index > rowSpanStart && index <= rowSpanEnd) {
              onCellObj = { ...onCellObj, rowSpan: 0 };
            }
          }
          if (col.colSpan) {
            const colSpanStart =
              col.colSpanStart && col.colSpanStart > 0
                ? col.colSpanStart - 1
                : 0;
            const SpanEnd =
              col.colSpanEnd && data.length >= col.colSpanEnd
                ? col.colSpanEnd
                : data.length;

            if (index === colSpanStart) {
              onCellObj = {
                ...onCellObj,
                colSpan: SpanEnd - colSpanStart,
              }; // Apply rowspan to the first row
            } else if (index > colSpanStart && index <= SpanEnd) {
              onCellObj = { ...onCellObj, colSpan: 0 };
            }
          }
          return onCellObj;
        },
      };
    })
    .filter((column: any) => visibleColumns.includes(column.dataIndex));

  const newupdatedColumns = [...mergedColumns];

  const EditableCell: React.FC<any> = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    children,
    ...restProps
  }) => {
    //const inputNode = inputType === "number" ? <Input type="number" /> : <Input />;
    const [form1] = Form.useForm();
    // const inputNode =
    //   inputType === "number" ? <Input type="number" /> : <Input />;
    const inputNode = inputType ? ( inputType === "number" ? <InputNumber /> : <Input />) : <Input />;

    console.log(
      "dataIndex",
      dataIndex,
      "title",
      title,
      "keyIdentity",
      keyIdentity
    );

    const inputRef = React.useRef<any>(null); // Local ref for the input element
    return (
      <td {...restProps}>
        <Form form={form1} component={false}>
          {editing ? (
            <Form.Item
              name={dataIndex}
              style={{ margin: 0 }}
              rules={[
                {
                  required: true,
                  message: `Please Input ${title}!`,
                },
                {
                  validator: async (_: any, value: any) => {
                    if (dataIndex === "age" && isNaN(value)) {
                      return Promise.reject(
                        new Error("Age should be a number")
                      );
                    }
                    if (dataIndex === "age" && value <= 15) {
                      return Promise.reject(new Error("Age should be > 15"));
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              {React.cloneElement(inputNode, {
                ref: inputRef,
                defaultValue: record[dataIndex],
                onBlur: (e: any) => {
                  save(record.key, e.target.value, dataIndex, form1);
                },

                onMouseEnter: () => {
                  // Optionally, highlight the input field when hovered
                  inputRef.current.focus();
                },
              })}
            </Form.Item>
          ) : (
            children
          )}
        </Form>
      </td>
    );
  };

  const handleTableChange = (pagination: any, extra: any) => {
    const newColumns = updatedColumns.map((column: any) => {
      return (column.filterIcon = (filtered: any) => (
        <div
          style={{ display: "flex", justifyContent: "space-between", gap: 3 }}
        >
          <BsThreeDotsVertical
            style={{
              color: filtered ? "blue" : "black",
              fontSize: "18px",
            }}
          />
        </div>
      ));
    });

    setUpdatedColumns(newColumns);
    onChange?.(pagination, extra);
  };

  // Handle opening the column management modal
  const handleManageColumns = () => {
    setVisibleColumnsModalVisible(true);
  };

  // Handle closing the modal
  const handleCancel = () => {
    setVisibleColumnsModalSearchText("");
    setVisibleColumnsModalVisible(false);
  };

  // Handle column visibility toggle
  const handleColumnToggle = (columnKey: string, checked: boolean) => {
    setVisibleColumns((prevVisibleColumns) =>
      checked
        ? [...prevVisibleColumns, columnKey]
        : prevVisibleColumns.filter((key) => key !== columnKey)
    );
  };

  // Handle search input change
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    //console.log(e.target.value);
    setVisibleColumnsModalSearchText(e.target.value);
  };

  // Render the column visibility management modal
  const renderColumnVisibilityModal = () => (
    <Modal
      title="Manage Columns"
      visible={isVisibleColumnsModalVisible}
      onCancel={handleCancel}
      footer={null}
      width={300} // Adjust the width of the modal
      style={{
        maxHeight: "400px", // Medium height for the modal
        // Enable scrolling for content inside the modal
      }}
    >
      <div>
        {/* Search input field */}
        <Input
          placeholder="Search Columns"
          value={visibleColumnsModalSearchText}
          onChange={handleSearchChange}
          style={{ marginBottom: 15 }}
        />

        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button onClick={handleCancel}>Close</Button>
        </div>
      </div>
    </Modal>
  );

  // For the row selection.
  const rowSelection: TableProps<DataType>["rowSelection"] = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: DataType[]) => {
      console.log(
        `selectedRowKeys: ${selectedRowKeys}`,
        "selectedRows: ",
        selectedRows
      );
    },
    getCheckboxProps: (record: DataType) => ({
      disabled: record.name === "Disabled User", // Column configuration not to be checked
      name: record.name,
    }),
  };

  return (
    <Form form={form} component={false} style={{ width: "100%" }}>
      {renderColumnVisibilityModal()}
      <Form.Item name={name} hidden>
        <Input />
      </Form.Item>
      <Table
        components={{
          body: {
            cell: EditableCell,
          },
        }}
        scroll={{ x: "max-content" }}
        bordered
        dataSource={data}
        columns={newupdatedColumns}
        rowClassName="editable-row"
        style={{ width: "100%" }}
        onChange={handleTableChange}
        pagination={{
          onChange: () => {},
          position: ["bottomRight"],
        }}
        {...rest}
      />
    </Form>
  );
};

export default FormInlineTable;
